import leoPic from "@/public/images/artists/leo.png";
import { Artist } from "@/types/types";

export const leo = {
  id: "190",
  name: "Leo",
  image: leoPic,
  description: `Leo's voice has a uniquely resonant and fluid quality, marked by rich, throaty undertones and a seamless transition between registers.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fleo-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: [
        "Unprocessed",
        "Deep",
        "Soundtrack",
        "Ballads",
        "Classical",
        "Soul",
        "RnB",
      ],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Bass",
        high: "Mid",
      },
      specific: {
        low: 44,
        high: 70,
      },
      sweetSpot: 56,
    },
  },
} as const satisfies Artist;
